import { useEffect, useRef } from 'react'
import { useTimeStore } from '@store/common/useTimeStore.js'
import { getIsExactTime } from '@utils/getTime.js'

export const usePolling = (refetch, period = '5m', { enabled = true } = {}) => {
  const updateBaseTime = useTimeStore((s) => s.updateBaseTime)
  const intervalRef = useRef(null)
  const hasRefetchedRef = useRef(false)

  useEffect(() => {
    if (!enabled) return

    updateBaseTime() // 진입 시 바로 5분 정렬 baseTime 갱신

    intervalRef.current = setInterval(() => {
      const now = useTimeStore.getState().getBaseTime()
      const isExactTime = getIsExactTime(now, period)

      if (isExactTime && !hasRefetchedRef.current) {
        hasRefetchedRef.current = true

        updateBaseTime()
        refetch()
      }

      // 서버 시간 기준으로 원하는 순간이 아닐 때 중복 호출을 막기 위한 플래그 초기화
      if (!isExactTime) {
        hasRefetchedRef.current = false
      }
    }, 1000)

    return () => clearInterval(intervalRef.current)
  }, [period, refetch, updateBaseTime, enabled])
}
